import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "folder-content content-panel" }
const _hoisted_2 = {
  role: "region",
  title: "Archive",
  "aria-label": "Archive",
  class: "sessions-panel"
}
const _hoisted_3 = {
  key: 0,
  class: "subheader"
}

import { ref, useTemplateRef, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import BaseView from "../views/BaseView.vue";
import ItemList from "../components/Home/ItemList.vue";
import { SessionWithOrdersAndType } from "@/types/session-interfaces";
import { ItemListColumn } from "@/types/itemlist-interfaces";
import { Folder } from "@/types/folder-interfaces";


import { onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Archive',
  setup(__props) {

const router = useRouter(),
    store = useStore();

const loader = ref<boolean>(false),
    archiveItemListRef = useTemplateRef("archiveItemList"),
    archiveList = ref();

const columns: ItemListColumn[] = [
{ 
  field: "title", 
  header: "TITLE", 
  sortable: true, 
  width: "30.44%",
},
{
  field: "noteStatus",
  header: "NOTES STATUS",
  sortable: true,
  width: "14.58%",
},
{
  field: "uploads",
  sortable: true,
  sortFunction: (
    session1: SessionWithOrdersAndType,
    session2: SessionWithOrdersAndType
  ) => {
    const uploads1 = session1.uploads || [];
    const uploads2 = session2.uploads || [];
    return uploads1.length - uploads2.length;
  },
  header: "SUPPLEMENTARY FILES",
  width: "18.75%",
},
{
  field: "createdAt",
  header: "CREATED",
  sortable: true,
  width: "17.36%",
},
{ 
  field: "num", 
  header: "", 
  icon: true, 
  width: "18.86%", 
},
];


const openSession = (session: SessionWithOrdersAndType) => {
store.commit("user/setSessionDetails", {
  status: session.noteStatus,
  statusDetail: session.orderStatus,
  order: session.orders,
  ...session,
});
router.push({
  name: "SessionInitializer",
});
};

const goToFolder = (folder: Folder) => {
router.push(`/folder/${folder.id}?title=${folder.title}&isArchived=true`);
};

const archivedItems = computed({
get: () =>  store.getters['itemList/getArchivedItems'],
set: (val) => store.dispatch('itemList/updateArchivedItems', val),
});

const allItems = computed(() => store.getters['itemList/getAllItems']);

onMounted(() => {
if (allItems.value.length === 0) {
  store.dispatch('itemList/fetchAllData');
}
archiveList.value = archiveItemListRef.value;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseView, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("main", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "header" }, "Archive", -1)),
          (archivedItems.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " No sessions or folders have been archived. "))
            : (_openBlock(), _createBlock(ItemList, {
                key: 1,
                ref: "archiveItemList",
                data: archivedItems.value,
                columns: columns,
                loader: loader.value,
                openSession: openSession,
                openFolder: goToFolder,
                isArchive: true,
                scrollHeight: '100vh',
                lazyLoading: false,
                storageKey: "archive-table"
              }, null, 8, ["data", "loader"]))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})